/* tj-mayoreo.js — lógica de la PDP de Mayoreo TUS JERSEYS (matriz, niveles, paquetes, carrito) */
(function () {
  'use strict';
  var root = document.querySelector('[data-tj-pdp]');
  if (!root) return;
  var C;
  try { C = JSON.parse(root.querySelector('script[data-tj-config]').textContent); } catch (e) { console.error('[TJ] config', e); return; }

  /* ---------- Normalizar configuración ---------- */
  var num = function (x) { return parseFloat(String(x).replace(/[^0-9.]/g, '')) || 0; };
  var niveles = C.niveles.map(num).filter(function (n) { return n > 0; });
  var precios = { fan: C.precios.fan.map(num), player: C.precios.player.map(num) };
  var nombres = (C.nombres || []).map(function (x) { return String(x).trim(); });
  var HEAD_BG = ['#E9EAEC', '#DCEDE3', '#E6E0F3', '#DCE8F4', '#F3E8CE', '#F0DFDB'];
  var HEAD_FG = ['#3F4450', '#2E5B40', '#4B3F78', '#2F4F74', '#6A5220', '#7A3E34'];
  var tallas = C.tallas.map(function (l) { var p = String(l).split('|').map(function (x) { return x.trim(); }); return p[0] ? { t: p[0], ancho: p[1] || '', largo: p[2] || '' } : null; }).filter(Boolean);
  var TALLAS = tallas.map(function (x) { return x.t; });
  var curva = {};
  String(C.curva || '').split(',').forEach(function (kv) { var p = kv.split(':'); if (p[0] && p[0].trim()) curva[p[0].trim()] = num(p[1]); });
  var VERS = ['fan', 'player'];
  var LABELS = C.labels;

  function prep(m) {
    var v = { fan: {}, player: {} };
    (m.vars || []).forEach(function (x) { if (!v[x.ver]) v[x.ver] = {}; v[x.ver][x.t] = x.id; });
    m.v = v; return m;
  }
  var models = (C.models || []).map(prep);
  if (!models.some(function (m) { return m.handle === C.current; })) models.unshift(prep(C.self));
  var byHandle = {}; models.forEach(function (m) { byHandle[m.handle] = m; });

  /* ---------- Estado ---------- */
  var KEY = 'tj-mayoreo-qty';
  var S = {
    sel: Math.max(0, models.findIndex(function (m) { return m.handle === C.current; })),
    ver: 'fan', qty: {}, img: 0, sheet: null, zoom: false, matrixVis: false, prevTier: 0
  };
  try { S.qty = JSON.parse(sessionStorage.getItem(KEY) || '{}') || {}; } catch (e) { S.qty = {}; }
  Object.keys(S.qty).forEach(function (k) { if (!byHandle[k.split('|')[0]]) delete S.qty[k]; });
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(S.qty)); } catch (e) {} }

  /* ---------- Utilidades ---------- */
  var $ = function (sel, el) { return (el || document).querySelector(sel); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  function fmt(n) { return '$' + Math.round(n).toLocaleString('es-MX'); }
  function key(h, v, t) { return h + '|' + v + '|' + t; }
  function totalOf(q) { var s = 0; for (var k in q) s += q[k]; return s; }
  function tierOf(total) { var i = 0; niveles.forEach(function (n, k) { if (total >= n) i = k; }); return i; }
  function priceOf(v, tier) { var a = precios[v]; return a[Math.min(tier, a.length - 1)]; }
  function rango(i) { var min = niveles[i], nx = niveles[i + 1]; return nx ? min + ' a ' + (nx - 1) + ' pz' : min + '+ pz'; }
  function wa(msg) { return 'https://wa.me/' + C.whatsapp + '?text=' + encodeURIComponent(msg); }
  function img(m, i, big) { var a = m.images || []; var x = a[i]; return x ? (big ? x.src : x.thumb) : ''; }
  function imgCount(m) { return (m.images && m.images.length) || 8; }
  function imgTag(src, cls, alt) { return src ? '<img src="' + esc(src) + '" alt="' + esc(alt || '') + '" class="tj-img-fill ' + (cls || '') + '" loading="lazy">' : ''; }
  function ph(txt) { return '<span class="tj-ph">' + esc(txt) + '</span>'; }
  var check = '<svg width="12" height="12" viewBox="0 0 12 12"><path d="M2.5 6.2l2.4 2.3 4.6-5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function setQty(k, n) {
    n = Math.max(0, Math.min(9999, parseInt(n, 10) || 0));
    if (n) S.qty[k] = n; else delete S.qty[k];
    save(); render();
  }
  function distribute(n) {
    var sizes = TALLAS.filter(function (t) { return curva[t] > 0; });
    var sum = sizes.reduce(function (a, t) { return a + curva[t]; }, 0) || 1;
    var raw = sizes.map(function (t) { return { t: t, v: n * curva[t] / sum }; }), out = {};
    raw.forEach(function (r) { out[r.t] = Math.floor(r.v); });
    var rest = n - raw.reduce(function (a, r) { return a + Math.floor(r.v); }, 0);
    raw.slice().sort(function (a, b) { return (b.v % 1) - (a.v % 1); }).forEach(function (r) { if (rest > 0) { out[r.t]++; rest--; } });
    return out;
  }

  var toastT;
  function toast(msg) {
    var t = $('[data-tj-toast]', root); t.textContent = msg; t.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(function () { t.hidden = true; }, 3200);
  }
  function scrollTo(el) { if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 12, behavior: 'smooth' }); }

  /* ---------- Render ---------- */
  function renderGallery() {
    var m = models[S.sel], n = imgCount(m), has = m.images && m.images.length;
    var th = '', sl = '';
    for (var i = 0; i < n; i++) {
      var num2 = (i + 1 < 10 ? '0' : '') + (i + 1), lab = LABELS[i] || ('Foto ' + (i + 1));
      th += '<button type="button" class="tj-thumb" data-act="img" data-i="' + i + '" aria-label="Ver foto: ' + esc(lab) + '" aria-current="' + (i === S.img) + '">' + ph(num2) + imgTag(has ? img(m, i) : '', '', '') + '</button>';
      sl += '<button type="button" class="tj-slide" data-act="zoom" aria-label="Ampliar foto: ' + esc(lab) + '">' + (has ? imgTag(img(m, i, true), '', m.images[i].alt) : ph('FOTO · ' + lab)) + '</button>';
    }
    $('[data-tj-thumbs]', root).innerHTML = th;
    var g = $('[data-tj-gal]', root); g.innerHTML = sl; g.scrollLeft = 0;
    var b = $('[data-tj-badge]', root); b.textContent = m.badge || ''; b.hidden = !m.badge; b.setAttribute('data-express', String(!!m.express));
    updateCounter();
  }
  function updateCounter() {
    var m = models[S.sel];
    $('[data-tj-counter]', root).textContent = (S.img + 1) + ' / ' + imgCount(m);
    root.querySelectorAll('[data-tj-thumbs] .tj-thumb').forEach(function (t, i) { t.setAttribute('aria-current', String(i === S.img)); });
  }
  function goImg(i) {
    var n = imgCount(models[S.sel]); i = (i + n) % n; S.img = i;
    var g = $('[data-tj-gal]', root); g.scrollTo({ left: i * g.clientWidth, behavior: 'smooth' });
    updateCounter(); if (S.zoom) renderZoom();
  }

  function renderHead() {
    var m = models[S.sel];
    $('[data-tj-title]', root).textContent = m.title;
    $('[data-tj-sold]', root).textContent = '🔥 ' + Number(m.sold || 0).toLocaleString('es-MX') + ' vendidas';
    $('[data-tj-p1]', root).textContent = fmt(priceOf(S.ver, 0)) + ' MXN';
    $('[data-tj-men]', root).textContent = 'Mayoreo desde ' + fmt(priceOf(S.ver, niveles.length - 1));
    $('[data-tj-msel]', root).textContent = m.title;
    $('[data-tj-mcount]', root).textContent = models.length + ' DISPONIBLES';
  }

  function calc() {
    var q = S.qty, total = totalOf(q), tier = tierOf(total), sub = 0, men = 0;
    for (var k in q) { var v = k.split('|')[1]; sub += q[k] * priceOf(v, tier); men += q[k] * precios[v][0]; }
    var cur = priceOf(S.ver, tier);
    var unit = total ? sub / total : cur;
    var msg, short, pct, last = niveles.length - 1;
    if (tier < last) {
      var nx = niveles[tier + 1], base = (total === 0 || tier === 0) ? 0 : niveles[tier], faltan = nx - total;
      var pzTxt = faltan === 1 ? 'pieza' : 'piezas', mas = total ? ' más' : '';
      pct = Math.max(0, Math.min(100, Math.round((total - base) / (nx - base) * 100)));
      var np = fmt(priceOf(S.ver, tier + 1)); msg = 'Agrega ' + faltan + ' ' + pzTxt + mas + ' y baja a ' + np + ' c/u'; short = '+' + faltan + ' pz → ' + np + ' c/u';
    } else { pct = 100; msg = 'Ya tienes el mejor precio: ' + fmt(cur) + ' c/u'; short = 'Mejor precio'; }
    return { total: total, tier: tier, sub: sub, men: men, cur: cur, unit: unit, msg: msg, short: short, pct: pct };
  }

  function renderTiers(c) {
    var last = niveles.length - 1;
    $('[data-tj-tiers]', root).innerHTML = niveles.map(function (n, i) {
      var act = i === c.tier && c.total > 0, next = c.total === 0 ? i === 1 : i === c.tier + 1;
      var estado = act ? 'Tu nivel' : next ? 'Siguiente rango' : 'Por alcanzar';
      var off = Math.round((1 - priceOf(S.ver, i) / precios[S.ver][0]) * 100), best = i === last;
      return '<div class="tj-lv" data-active="' + act + '" data-best="' + best + '">' + (best ? '<span class="tj-lv__best">MEJOR PRECIO</span>' : '') +
        '<div class="tj-lv__n" style="background:' + HEAD_BG[i % 6] + ';color:' + HEAD_FG[i % 6] + '">' + esc(nombres[i] || ('Nivel ' + (i + 1))) + '</div>' +
        (off > 0 ? '<span class="tj-lv__off">-' + off + '%</span>' : '<span class="tj-lv__off tj-lv__off--0">precio base</span>') +
        '<div class="tj-lv__r">' + rango(i).replace(' a ', '–') + '</div><div class="tj-lv__p">' + fmt(priceOf(S.ver, i)) + '</div><div class="tj-lv__c">c/u</div>' +
        (act ? '<span class="tj-lv__s"><i></i>' + estado + '</span>' : '') + '</div>';
    }).join('');
    var calcEl = $('[data-tj-calc]', root);
    if (C.calc) {
      calcEl.hidden = false;
      var men = precios[S.ver][0];
      calcEl.innerHTML = 'Si revendes a <b>' + fmt(men) + '</b>, ganas <b class="tj-calc__m">' + fmt(men - c.cur) + '</b> por pieza';
    }
  }

  function renderModels() {
    var h = '';
    models.forEach(function (m, i) {
      var sel = i === S.sel;
      h += '<button type="button" class="tj-mcard" data-act="pick" data-i="' + i + '" aria-pressed="' + sel + '" aria-label="' + esc(m.title) + ', ranking número ' + (i + 1) + '">' +
        '<div class="tj-mcard__box"><div class="tj-mcard__in">' + imgTag(img(m, 0), '', m.title) + '</div>' +
        '<span class="tj-rank">#' + (i + 1) + '</span><span class="tj-check">' + check + '</span></div>' +
        '<span class="tj-mcard__n">' + esc(m.title) + '</span></button>';
    });
    $('[data-tj-mcards]', root).innerHTML = h;
  }

  function rowsHtml(m, sheet) {
    return tallas.map(function (s) {
      var k = key(m.handle, S.ver, s.t), n = S.qty[k] || 0, foto = img(m, 0);
      var stepper = '<div class="tj-stepper" role="group" aria-label="Cantidad talla ' + esc(s.t) + '">' +
        '<button type="button" data-act="dec" data-k="' + esc(k) + '" aria-label="Quitar una pieza talla ' + esc(s.t) + '">–</button>' +
        '<input type="text" inputmode="numeric" pattern="[0-9]*" aria-label="Piezas talla ' + esc(s.t) + '" value="' + n + '" data-k="' + esc(k) + '">' +
        '<button type="button" data-act="inc" data-k="' + esc(k) + '" aria-label="Agregar una pieza talla ' + esc(s.t) + '">+</button></div>';
      if (sheet) return '<div class="tj-srow"><div class="tj-srow__l"><div class="tj-srow__img">' + imgTag(foto) + '</div><div><div class="tj-srow__t">' + esc(s.t) + '</div><div class="tj-srow__m">' + esc(s.ancho) + ' × ' + esc(s.largo) + ' cm</div></div></div>' + stepper + '</div>';
      return '<div class="tj-row"><div class="tj-row__img">' + imgTag(foto) + '</div><div class="tj-row__t">' + esc(s.t) + '</div>' + stepper + '</div>';
    }).join('');
  }

  function renderMatrix(c) {
    var m = models[S.sel];
    $('[data-tj-vers]', root).innerHTML = VERS.map(function (v) {
      var sel = v === S.ver;
      return '<button type="button" class="tj-ver" data-act="ver" data-v="' + v + '" aria-pressed="' + sel + '" title="' + esc(C.versiones[v].desc) + '">' + esc(C.versiones[v].nombre) + ' · ' + fmt(priceOf(v, 0)) + '</button>';
    }).join('');
    $('[data-tj-verdesc]', root).textContent = C.versiones[S.ver].desc + ' ' + (C.notaTallas || '');
    var guia = '<div class="tj-guia__r tj-guia__h"><span>Talla</span><span>Ancho</span><span>Largo</span></div>' +
      tallas.map(function (g) { return '<div class="tj-guia__r"><b>' + esc(g.t) + '</b><span>' + esc(g.ancho) + ' cm</span><span>' + esc(g.largo) + ' cm</span></div>'; }).join('');
    $('[data-tj-guia]', root).innerHTML = guia;
    var rows = $('[data-tj-rows]', root), active = document.activeElement, focusK = active && rows.contains(active) && active.tagName === 'INPUT' ? active.dataset.k : null;
    rows.innerHTML = rowsHtml(m, false);
    if (focusK) { var el = rows.querySelector('input[data-k="' + CSS.escape(focusK) + '"]'); if (el) el.focus(); }
    $('[data-tj-total]', root).textContent = c.total;
  }

  function renderResumen(c) {
    $('[data-tj-progmsg]', root).textContent = c.msg;
    $('[data-tj-progfill]', root).style.width = c.pct + '%';
    $('[data-tj-progbar]', root).setAttribute('aria-valuenow', c.pct);
    var u = $('[data-tj-unit]', root); u.textContent = fmt(c.unit) + ' c/u';
    if (c.tier > S.prevTier && c.total > 0) { u.classList.add('is-bump'); setTimeout(function () { u.classList.remove('is-bump'); }, 420); }
    S.prevTier = c.tier;
    $('[data-tj-subtotal]', root).textContent = fmt(c.sub);
    var ah = $('[data-tj-ahorro]', root); ah.hidden = !(c.men - c.sub > 0);
    ah.innerHTML = 'Ahorras <span>' + fmt(c.men - c.sub) + '</span> vs menudeo';
    var groups = {}, order = [];
    Object.keys(S.qty).forEach(function (k) {
      var p = k.split('|'), gk = p[0] + '|' + p[1];
      if (!groups[gk]) { groups[gk] = { h: p[0], v: p[1], pz: 0, t: {} }; order.push(gk); }
      groups[gk].pz += S.qty[k]; groups[gk].t[p[2]] = S.qty[k];
    });
    var L = $('[data-tj-lines]', root);
    L.hidden = !order.length;
    L.innerHTML = order.map(function (gk) {
      var g = groups[gk], m = byHandle[g.h];
      var tt = TALLAS.filter(function (t) { return g.t[t]; }).map(function (t) { return t + ' ' + g.t[t]; }).join(' · ');
      return '<div class="tj-line"><div class="tj-line__i"><div class="tj-line__n">' + esc(m.title) + ' · ' + esc(C.versiones[g.v].nombre) + ' · ' + g.pz + ' pz</div><div class="tj-line__t">' + esc(tt) + '</div></div>' +
        '<button type="button" class="tj-line__e" data-act="edit" data-g="' + esc(gk) + '">Editar</button>' +
        '<button type="button" class="tj-line__x" data-act="remove" data-g="' + esc(gk) + '" aria-label="Quitar ' + esc(m.title) + '">✕</button></div>';
    }).join('');
    var m = models[S.sel], T = C.tiempos;
    $('[data-tj-envio]', root).textContent = (m.express ? 'Envío Express en ' + T.express : 'Envío de stock en ' + T.stock) + ' días hábiles · Pedidos sobre producción: ' + T.produccion + ' días hábiles';
  }

  function renderSticky(c) {
    var st = $('[data-tj-sticky]', root), on = !!C.sticky && window.innerWidth < 900;
    st.hidden = !on; document.body.classList.toggle('tj-has-sticky', on);
    $('[data-tj-sprog]', root).style.width = c.pct + '%';
    $('[data-tj-sshort]', root).textContent = c.short;
    $('[data-tj-ssum]', root).textContent = c.total + ' pz · ' + fmt(c.sub);
    var b = $('[data-tj-bubble]', root);
    if (b) { b.hidden = S.matrixVis || S.sheet != null || S.zoom; b.href = wa(String(C.msgDuda || '').replace('[MODELO]', models[S.sel].title)); }
  }

  function renderSheet(c) {
    var el = $('[data-tj-sheet]', root);
    if (S.sheet == null) { el.hidden = true; return; }
    var m = models[S.sheet]; el.hidden = false;
    $('[data-tj-sname]', root).textContent = m.title;
    $('[data-tj-sver]', root).innerHTML = 'Versión ' + esc(C.versiones[S.ver].nombre) + ' · <b>' + fmt(priceOf(S.ver, c.tier)) + ' c/u</b>';
    var rows = $('[data-tj-srows]', root), a = document.activeElement, fk = a && rows.contains(a) && a.tagName === 'INPUT' ? a.dataset.k : null;
    rows.innerHTML = rowsHtml(m, true);
    if (fk) { var e = rows.querySelector('input[data-k="' + CSS.escape(fk) + '"]'); if (e) e.focus(); }
    $('[data-tj-smsg]', root).textContent = c.msg;
    $('[data-tj-sdone]', root).textContent = 'Listo · ' + c.total + ' pz en tu pedido';
  }

  function renderZoom() {
    var z = $('[data-tj-zoom]', root); z.hidden = !S.zoom; if (!S.zoom) return;
    var m = models[S.sel], lab = LABELS[S.img] || '';
    $('[data-tj-zlabel]', root).textContent = (S.img + 1) + ' / ' + imgCount(m) + ' · ' + lab;
    var src = img(m, S.img, true), box = $('[data-tj-zimg]', root);
    box.innerHTML = src ? imgTag(src, '', lab) : ph(lab);
  }

  function renderOthers(c) {
    var box = document.querySelector('[data-tj-others]'); if (!box) return;
    box.innerHTML = models.map(function (m, i) {
      if (i === S.sel) return '';
      var pz = 0; Object.keys(S.qty).forEach(function (k) { if (k.indexOf(m.handle + '|') === 0) pz += S.qty[k]; });
      return '<div class="tj-ocard"><div class="tj-ocard__img">' + imgTag(img(m, 0), '', m.title) + '<span class="tj-rank">#' + (i + 1) + '</span></div>' +
        '<div class="tj-ocard__n">' + esc(m.title) + '</div><div class="tj-ocard__s">🔥 ' + Number(m.sold || 0).toLocaleString('es-MX') + ' vendidas</div>' +
        '<div class="tj-ocard__f"><span class="tj-ocard__p">' + fmt(priceOf(S.ver, 0)) + '</span><button type="button" class="tj-plus" data-act="sheet" data-i="' + i + '" aria-label="Agregar ' + esc(m.title) + '">+</button></div>' +
        (pz ? '<div class="tj-ocard__in">En tu pedido: ' + pz + ' pz</div>' : '') + '</div>';
    }).join('');
  }

  function pkgData(el) { try { return JSON.parse(el.getAttribute('data-tj-pkg')); } catch (e) { return null; } }
  function renderPkgs() {
    document.querySelectorAll('[data-tj-pkg]').forEach(function (el) {
      var p = pkgData(el); if (!p) return;
      var hs = p.handles.filter(function (h) { return byHandle[h]; }), pz = hs.length * p.pz, t = tierOf(pz);
      var tot = hs.length * p.pz * priceOf(p.ver, t), d = distribute(p.pz);
      var set = function (f, v) { var x = el.querySelector('[data-f="' + f + '"]'); if (x) x.textContent = v; };
      set('nivel', 'Nivel ' + (t + 1) + ' · ' + rango(t));
      set('modelos', hs.map(function (h) { return byHandle[h].title; }).join(' · ') || 'Elige los modelos en el editor de temas');
      set('curva', TALLAS.filter(function (x) { return d[x]; }).map(function (x) { return x + ' ' + d[x]; }).join(' · '));
      set('pz', pz); set('unit', pz ? fmt(tot / pz) : '—'); set('total', fmt(tot) + ' MXN');
    });
  }

  function renderAccordions() {
    document.querySelectorAll('[data-tj-ficha]').forEach(function (el) { el.hidden = el.getAttribute('data-tj-ficha') !== S.ver; });
    document.querySelectorAll('[data-tj-vername]').forEach(function (el) { el.textContent = String(C.versiones[S.ver].nombre).toUpperCase(); });
    document.querySelectorAll('[data-tj-guiaacc]').forEach(function (el) {
      el.innerHTML = '<div class="tj-guia__r tj-guia__h"><span>Talla</span><span>Ancho (cm)</span><span>Largo (cm)</span></div>' +
        tallas.map(function (g) { return '<div class="tj-guia__r"><b>' + esc(g.t) + '</b><span>' + esc(g.ancho) + '</span><span>' + esc(g.largo) + '</span></div>'; }).join('') +
        '<p style="margin-top:8px">' + esc(C.notaTallas || '') + '</p>';
    });
  }

  function render(full) {
    var c = calc();
    if (full) { renderGallery(); renderModels(); renderPkgs(); }
    renderHead(); renderTiers(c); renderMatrix(c); renderResumen(c); renderSticky(c); renderSheet(c); renderZoom(); renderOthers(c); renderAccordions();
    if (!full) root.querySelectorAll('.tj-mcard').forEach(function (b, i) { b.setAttribute('aria-pressed', String(i === S.sel)); });
  }

  /* ---------- Carrito ---------- */
  async function addAll() {
    var total = totalOf(S.qty);
    if (!total) { toast('Captura piezas en la matriz de tallas'); scrollTo($('[data-tj-matrix]', root)); return; }
    var missing = 0, items = Object.keys(S.qty).map(function (k) {
      var p = k.split('|'), m = byHandle[p[0]], id = m && m.v[p[1]] && m.v[p[1]][p[2]];
      if (!id) missing++;
      return { id: id, quantity: S.qty[k] };
    });
    if (missing) { toast('Falta la variante de ' + missing + ' combinación(es). Revisa las opciones Versión/Talla del producto.'); return; }
    var btns = root.querySelectorAll('[data-act="addall"]');
    btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    try {
      var res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
      if (!res.ok) { var j = {}; try { j = await res.json(); } catch (e) {} throw new Error(j.description || ('cart/add ' + res.status)); }
      S.qty = {}; save();
      window.location.href = C.cartUrl || '/cart';
    } catch (e) {
      console.error('[TJ]', e);
      toast('No se pudo agregar. Intenta de nuevo o escríbenos por WhatsApp.');
      btns.forEach(function (b) { b.removeAttribute('aria-busy'); });
    }
  }

  /* ---------- Eventos ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-act]');
    if (!t) return;
    if (t.hasAttribute('data-stop') || (e.target.closest('[data-stop]') && t.getAttribute('data-act') === 'closesheet' && t.classList.contains('tj-overlay'))) return;
    var a = t.getAttribute('data-act');
    switch (a) {
      case 'img': goImg(+t.dataset.i); break;
      case 'prev': goImg(S.img - 1); break;
      case 'next': goImg(S.img + 1); break;
      case 'zoom': S.zoom = true; $('[data-tj-zimg]', root).classList.remove('is-big'); render(); break;
      case 'closezoom': S.zoom = false; render(); break;
      case 'zoombig': t.classList.toggle('is-big'); break;
      case 'rules': { var o = t.getAttribute('aria-expanded') === 'true'; t.setAttribute('aria-expanded', String(!o)); $('[data-tj-rules]', root).hidden = o; break; }
      case 'guia': { var g = t.getAttribute('aria-expanded') === 'true'; t.setAttribute('aria-expanded', String(!g)); $('[data-tj-guia]', root).hidden = g; break; }
      case 'pick': pick(+t.dataset.i); break;
      case 'ver': S.ver = t.dataset.v; render(true); break;
      case 'dec': setQty(t.dataset.k, (S.qty[t.dataset.k] || 0) - 1); break;
      case 'inc': setQty(t.dataset.k, (S.qty[t.dataset.k] || 0) + 1); break;
      case 'addall': addAll(); break;
      case 'edit': { var p = t.dataset.g.split('|'); pick(models.findIndex(function (m) { return m.handle === p[0]; })); S.ver = p[1]; render(true); scrollTo($('[data-tj-matrix]', root)); break; }
      case 'remove': { var pre = t.dataset.g + '|'; Object.keys(S.qty).forEach(function (k) { if (k.indexOf(pre) === 0) delete S.qty[k]; }); save(); render(); break; }
      case 'sheet': S.sheet = +t.dataset.i; render(); break;
      case 'closesheet': if (e.target.closest('[data-stop]') && t.classList.contains('tj-overlay')) return; S.sheet = null; render(); break;
      case 'addpkg': {
        var el = t.closest('[data-tj-pkg]'), pk = pkgData(el); if (!pk) break;
        var hs = pk.handles.filter(function (h) { return byHandle[h]; }); if (!hs.length) { toast('Este paquete no tiene modelos asignados'); break; }
        var d = distribute(pk.pz);
        hs.forEach(function (h) { Object.keys(d).forEach(function (tt) { if (d[tt]) { var k = key(h, pk.ver, tt); S.qty[k] = (S.qty[k] || 0) + d[tt]; } }); });
        save(); render(); toast(pk.nombre + ' agregado · ' + (hs.length * pk.pz) + ' pz');
        break;
      }
    }
  });
  document.addEventListener('change', function (e) {
    var i = e.target; if (i.tagName === 'INPUT' && i.dataset.k && i.closest('.tj-stepper')) setQty(i.dataset.k, String(i.value).replace(/\D/g, ''));
  });
  document.addEventListener('focusin', function (e) { var i = e.target; if (i.tagName === 'INPUT' && i.closest('.tj-stepper')) i.select(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { if (S.zoom) { S.zoom = false; render(); } else if (S.sheet != null) { S.sheet = null; render(); } }
    var i = e.target; if (e.key === 'Enter' && i.tagName === 'INPUT' && i.closest('.tj-stepper')) i.blur();
  });

  function pick(i) {
    if (i < 0) return;
    S.sel = i; S.img = 0;
    var m = models[i];
    try { if (m.url && history.replaceState) history.replaceState(null, '', m.url + location.search); } catch (e) {}
    render(true);
  }

  var gal = $('[data-tj-gal]', root);
  gal.addEventListener('scroll', function () { var i = Math.round(gal.scrollLeft / (gal.clientWidth || 1)); if (i !== S.img) { S.img = i; updateCounter(); } }, { passive: true });
  window.addEventListener('resize', function () { renderSticky(calc()); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { S.matrixVis = en[0].isIntersecting; renderSticky(calc()); }, { rootMargin: '0px 0px -40px 0px' }).observe($('[data-tj-matrix]', root));
  }

  render(true);
})();
